import { useContext, useMemo } from "react";
import { AppContext } from "../App";

const PRODUCT_LABELS = [
	{ key: "vegan", text: { it: "Vegano", en: "Vegan" } },
	{ key: "gluten_free", text: { it: "Senza glutine", en: "Gluten free" } },
	{ key: "disabled", text: { it: "Disabilitato", en: "Disabled" } },
];

function isActive(value) {
	return value === 1 || value === true || value === "1" || value === "true";
}

function normalizeText(value) {
	return String(value || "").trim().toLowerCase();
}

function resolveCustomLabel(item, lang, labels) {
	if (!Array.isArray(labels)) return "";
	const fallbackValues = [
		item.text.it,
		item.text.en,
		item.key,
	].map((value) => normalizeText(value));
	const match = labels.find((label) => {
		const candidates = [
			label?.o_it,
			label?.o_en,
			label?.it,
			label?.en,
			label?.src,
			label?.key,
			label?.name,
		].map((value) => normalizeText(value));
		return candidates.some((candidate) => fallbackValues.includes(candidate));
	});
	if (!match) return "";
	return match[lang] || match.it || match.en || "";
}

function getLabelText(item, lang, labels) {
	return (
		resolveCustomLabel(item, lang, labels) ||
		item.text[lang] ||
		item.text.it ||
		item.text.en ||
		item.key
	);
}

function ProductLabels({ product }) {
	const { labels, lang } = useContext(AppContext);

	const activeLabels = useMemo(() => {
		return PRODUCT_LABELS.filter((item) => isActive(product?.[item.key]));
	}, [product]);

	if (!activeLabels.length) return null;

	return (
		<div className="label">
			{activeLabels.map((item) => (
				<div
					key={item.key}
					className={`label-badge label-badge-${item.key}`}
				>
					{getLabelText(item, lang, labels)}
				</div>
			))}
		</div>
	);
}

export default ProductLabels;
